export { default as TolomButton } from "./button/tolom-button";
export { default as TolomButton2 } from "./button/tolom-button2";
export { default as InfoText } from "./info-text/info-text";
export { default as FaqBlock } from "./faq/faq";
